jQuery(function ($) {
  // URL情報の取得
  function getUrlInfo(){
    const path = location.pathname;
    decodePath = decodeURI(path);
    urlParam = /[^/]*$/.exec(decodePath)[0];
  }
  
  //パンくず
  $(function(){
    getUrlInfo();
    $('.js-currentPage').append(urlParam);
  });
  
  //検索プレスホルダー
  $('.m-search .search__input').attr('placeholder','キーワードで検索するか、質問を入力してください');

  // 詳細ページ：この記事は役に立ちましたか？
  $(function(){
    const btnYes = $('.js-fb-btnYes');
    const btnNo = $('.js-fb-btnNo');
    const txtYes = $('.js-fb-txtYes');
    const txtNo = $('.js-fb-txtNo');
    
    txtYes.hide();
    txtNo.hide();
    btnYes.on('click', function() {
      txtYes.show();
      txtNo.hide();
    });
    btnNo.on('click', function() {
      txtNo.show();
      txtYes.hide();
    });
  });
  
});

